/**
 * Handle homepage javascript behavior
 */

window.app = window.app || {};

(function (homeManager, $) {

    /**
     * Bubbles animation container selector
     * @private
     */
    var _bubbles = '.bubbles';

    /**
     * Home Header slideshow bxslider options
     * @type {string}
     */
    var _bxHeaderOptions = {
        autoStart: true,
        auto: true,
        controls: false,
        mode: 'fade',
        autoDelay: 1000,
        infiniteLoop: true,
        onSliderLoad: function() {
            $('.header-slideshow .bxslider>li').eq(0).addClass('loaded');
        },
        onSlideBefore: function($slideElement, oldIndex, newIndex) {
            $('.header-slideshow .bxslider>li').removeClass('loaded');
        },
        onSlideAfter: function($slideElement, oldIndex, newIndex) {
            $slideElement.addClass('loaded');
        }
    };

    /**
     * * Home Header custom block bxslider options
     * @private
     */
    var _bxCustomOptions = {
        mode: 'fade',
        autoStart: true,
        auto: true,
        controls: false,
        infiniteLoop: true
    };

    /**
     * Benefits block bxslider options
     * @private
     */
    var _bxBenefitsOptions = {
        auto: true,
        autoStart: true,
        autoHover: true,
        slideWidth: 280,
        minSlides: 2,
        maxSlides: 6,
        moveSlides: 2,
        pager: false,
        nextText: "",
        prevText: "",
        slideMargin: 10
    };

    /**
     * Initializes the behavior.
     */
    homeManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        _initBubbles();

        $(document).ready(function(){
            $('.header-slideshow .bxslider').bxSlider( _bxHeaderOptions );
            $('.block-custom .bxslider.fade-effect').bxSlider( _bxCustomOptions );
            $('.block-benefits .bxslider').bxSlider( _bxBenefitsOptions );

            _bxBenefitsOptions.slideWidth = 160;
            _bxBenefitsOptions.slideWidth = 160;
            _bxBenefitsOptions.auto = false;
            $('.logos-carousel .bxslider').bxSlider( _bxBenefitsOptions );
        });

        $('#home-video-modal').on('show.bs.modal', function() {
            $('#home-video-modal iframe').attr('src', $('#home-video iframe').attr('data-src'));
        });

        $('#home-video-modal').on('hide.bs.modal', function() {
            $('#home-video-modal iframe').removeAttr('src');
        });

        $('.scroll-down-btn').on('click', function() {
            var _elt = $(this).attr('data-target');
            $('body, html').animate({'scrollTop': $(_elt).offset().top + 'px' });
        });
    };

    /**
     * Bubbles function declaration
     */
    var _initBubbles = function() {

        var $bubbles = $(_bubbles);

        var min_bubble_count = 10,
            max_bubble_count = 15,
            min_bubble_size = 8,
            max_bubble_size = 24;

        var bubbleCount = min_bubble_count + Math.floor(Math.random() * (max_bubble_count + 1));

        for (var i = 0; i < bubbleCount; i++) {
            $bubbles.append('<div class="bubble-container"><div class="bubble"></div></div>');
        }

        $bubbles.find('.bubble-container').each(function(){
            var pos_rand = Math.floor(Math.random() * 101);
            var size_rand = min_bubble_size + Math.floor(Math.random() * (max_bubble_size + 1));
            var delay_rand = Math.floor(Math.random() * 16);
            var speed_rand = 1.5 + Math.random() * 20;
            var $this = $(this);
            $this.css({
                'left' : pos_rand + '%',
                '-webkit-animation-duration' : speed_rand + 's',
                '-moz-animation-duration' : speed_rand + 's',
                '-ms-animation-duration' : speed_rand + 's',
                'animation-duration' : speed_rand + 's',
                '-webkit-animation-delay' : delay_rand + 's',
                '-moz-animation-delay' : delay_rand + 's',
                '-ms-animation-delay' : delay_rand + 's',
                'animation-delay' : delay_rand + 's'
            });
            $this.children('.bubble').css({
                'width' : size_rand + 'px',
                'height' : size_rand + 'px'
            });
        });
    };
})(
    window.app.homeManager = window.app.homeManager || {},
    jQuery
);
